import React from "react";
import { Box } from "@mui/material";

import styles from "../AddVendorModal.module.css";

const FieldError = ({ error, className = styles.errorText }) =>
  error ? <Box className={className}>{error}</Box> : null;

export default FieldError;
